// No Tiptap imports: mobile app code imports this file, and Metro has no
// tree-shaking, so a Tiptap import here would ship the editor in the mobile app bundle.

// Matches timestamp patterns (e.g. 1:23, 0:10-0:20) while capturing an optional
// preceding character so callers can reject matches that appear inside URLs
// (after / or =) or version-like strings (after v or .).
const TIMESTAMP_INNER =
  /(\d{1,2}:[0-5]\d(?::[0-5]\d)?)(?:-(\d{1,2}:[0-5]\d(?::[0-5]\d)?))?/

// Characters that, when preceding a timestamp, indicate it is NOT a standalone
// timestamp (e.g. part of a URL or version string).
const REJECT_PRECEDING = new Set(['/', '=', 'v', '.'])

function createTimestampRegexGlobal() {
  return new RegExp(`([/=v.]?)\\b${TIMESTAMP_INNER.source}\\b`, 'g')
}

export type TimestampMatch = {
  index: number
  fullMatch: string
  start: string
  end: string | null
}

/**
 * Finds all timestamp matches in a text string, correctly rejecting
 * timestamps that appear inside URLs or version strings.
 */
export function findTimestamps(text: string): TimestampMatch[] {
  const re = createTimestampRegexGlobal()
  const results: TimestampMatch[] = []
  let match: RegExpExecArray | null
  while ((match = re.exec(text)) !== null) {
    // Group 1 is the optional preceding character — if it's in the reject
    // set, skip this match.
    if (match[1] && REJECT_PRECEDING.has(match[1])) {
      continue
    }
    // Compute the offset: if a preceding char was captured, the actual
    // timestamp starts one character later.
    const offset = match[1] ? 1 : 0
    results.push({
      index: match.index + offset,
      fullMatch: match[0].slice(offset),
      start: match[2]!,
      end: match[3] ?? null,
    })
  }
  return results
}

export function parseTimestampToSeconds(timestamp: string): number {
  const parts = timestamp.split(':').map(Number)
  if (parts.length === 3) {
    return parts[0]! * 3600 + parts[1]! * 60 + parts[2]!
  }
  return parts[0]! * 60 + parts[1]!
}
